import { Modal } from 'antd';
import React, { Component } from 'react'

class NoticeModal extends Component {
    constructor() {
        super();
        this.state = {
            
        }
    }

    render() {
        const { openModalNotice, handleSubmitRedeem, handleCancelRedeem } = this.props
        return (
            <Modal
                title="Thông báo" 
                visible={openModalNotice} 
                onOk={handleSubmitRedeem} 
                onCancel={handleCancelRedeem}
                okText="Xác nhận"
            >
                <h4>Lưu ý!</h4>
                <p>
                    Bạn đang thực hiện chức năng redeem không về khách sạn nội bộ. Nếu vé thực hiện redeem có chứa sản phẩm lưu trú, thao tác này sẽ không thể thực thi. <br /> Trường hợp vé không có sản phẩm lưu trú, hệ thống sẽ phân tách dòng tiền và tiến hành redeem.
                </p>
            </Modal>
        )
    }
}

export default NoticeModal